import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { ChartDisplayMode } from "../../enums/ChartDisplayMode.list";

@Injectable()
export class ChartDisplayModeService {
    public subscriber: Subject<ChartDisplayMode> = new Subject<ChartDisplayMode>();
}